import React from 'react';
import classnames from 'classnames';

const ModalContent = ({ children, className, renderAs, ...props }) => {
  const Element = renderAs;
  return (
    <Element {...props} className={classnames('modal-content', className)}>
      {children}
    </Element>
  );
};

ModalContent.defaultProps = {
  renderAs: 'div',
};

export default ModalContent;
